<template>
	<div :class="['planning-shell', { 'is-embedded': embedded }]">
		<PlanningViewMain
			:embedded="embedded"
			:target-driver-id="props.targetDriverId"
			:target-driver-ids="props.targetDriverIds"
			:target-date="props.targetDate"
			:selectable="props.selectable"
			:selected-driver-id="props.selectedDriverId"
			:driver-violations-counts="props.driverViolationsCounts"
			:custom-drivers="props.customDrivers"
			:custom-duties="props.customDuties"
			@select-driver="emit('select-driver', $event)"
			:range-from-status="props.rangeFromStatus"
			:range-to-status="props.rangeToStatus"
		/>
	</div>
</template>

<script setup lang="ts">
import PlanningViewMain from '@/rennovation/planning-view/containers/PlanningViewMain.vue';
import { ApiDriversResponse } from '@/rennovation/planning-view/types/api/users-response';
import { ApiDuty } from '@/rennovation/planning-view/types/api/duties-response';

const props = withDefaults(
	defineProps<{
		embedded?: boolean;
		targetDriverId?: string | null;
		targetDriverIds?: string[] | null;
		targetDate?: string | null;
		selectable?: boolean;
		selectedDriverId?: string | null;
		driverViolationsCounts?: Record<string, number> | null;
		rangeFromStatus?: string | null;
		rangeToStatus?: string | null;
		customDrivers?: ApiDriversResponse[] | null;
		customDuties?: Record<string, Record<string, ApiDuty>> | null;
	}>(),
	{
		embedded: true,
		targetDriverId: null,
		targetDriverIds: null,
		targetDate: null,
		selectable: false,
		selectedDriverId: null,
		driverViolationsCounts: null,
		rangeFromStatus: null,
		rangeToStatus: null,
		customDrivers: null,
		customDuties: null,
	}
);

const emit = defineEmits(['select-driver']);
</script>

<style scoped>
.planning-shell {
	width: 100%;
	display: flex;
	flex-direction: column;
}

.planning-shell.is-embedded {
	height: auto !important;
	min-height: 0 !important;
	margin: 0 !important;
}
</style>
